module.exports = __webpack_public_path__ + "static/media/filter.f148a387.svg";